
import Flag from '~/components/icons/Flag.vue';
import IconCaretRight from '~/components/icons/IconCaretRight.vue';
import IconCheckmark from '~/components/icons/IconCheckmark.vue';

const { disableBodyScroll, clearAllBodyScrollLocks } = require('body-scroll-lock');

export default {
  components: {
    Flag,
    IconCaretRight,
    IconCheckmark,
  },
  props: {
    expanded: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    languages() {
      return this.$store.state.languages;
    },
  },
  methods: {
    expand() {
      this.$emit('toggled', true);
      this.$nextTick(() => {
        disableBodyScroll(this.$el);
      });
    },
    collapse() {
      clearAllBodyScrollLocks();
      this.$emit('toggled', false);
    },
  },
};
